// import React, { useState, useEffect, useCallback } from "react";
// import Layout, { Container } from "../components/layout";
// import { AiTwotoneEdit } from "react-icons/ai";
// import { RiDeleteBin6Fill } from "react-icons/ri";
// import InputContainer from "../components/inputContainer";
// import { FiUpload } from "react-icons/fi";
// import { TiTick } from "react-icons/ti";
// import { RxCross2 } from "react-icons/rx";
// import { BlackButton } from "../components/buttonContainer";
// import { useUser } from "../config/userProvider";
// import axios from "axios";
// import { apiurl } from "../config/config";
// import loader, { DynamicLoader, InfiLoader } from "../components/loader";
// import Cropper from "react-easy-crop";
// import { IoClose } from "react-icons/io5";
// import { useTheme } from "../config/themeContext";
// import { LiaRedoAltSolid } from "react-icons/lia";

// function Documents() {
//   let { userData } = useUser();
//   const { vendor } = useTheme();
//   const [isOpen, setIsOpen] = useState(false);
//   const [showPopup, setShowPopup] = useState(false);
//   const [popupType, setPopupType] = useState("");
//   const [activeSection, setActiveSection] = useState("documentation");
//   const [updateDetail, setUpdateDetail] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [showImagePopup, setShowImagePopup] = useState(false);
//   const [selectedImage, setSelectedImage] = useState(null);
//   const [crop, setCrop] = useState({ x: 0, y: 0 });
//   const [zoom, setZoom] = useState(1);

//   const onClosePopup = () => {
//     setShowImagePopup(false);
//     setSelectedImage(null);
//   };

//   const handleImageChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       const imageUrl = URL.createObjectURL(file);
//       setSelectedImage(imageUrl);
//     }
//   };

//   const [croppedImage, setCroppedImage] = useState(null);
//   const [selectImage, setSelectImage] = useState(null);
//   const [logoUrl, setLogoUrl] = useState("");
//   const [logoUrlStatus, setLogoUrlStatus] = useState("");

//   const onCropComplete = useCallback(
//     (croppedArea, croppedAreaPixels) => {
//       // Ensure that the image is cropped after the cropping action is complete
//       generateCroppedImage(croppedAreaPixels);
//     },
//     [selectedImage]
//   );

//   const generateCroppedImage = async (croppedAreaPixels) => {
//     if (!selectedImage) return; // Ensure the image is set before processing
//     const image = new Image();
//     image.src = selectedImage;

//     image.onload = () => {
//       const canvas = document.createElement("canvas");
//       const ctx = canvas.getContext("2d");

//       // Set canvas size to the cropped area's dimensions
//       canvas.width = croppedAreaPixels.width;
//       canvas.height = croppedAreaPixels.height;

//       // Draw the cropped area onto the canvas
//       ctx.drawImage(
//         image,
//         croppedAreaPixels.x,
//         croppedAreaPixels.y,
//         croppedAreaPixels.width,
//         croppedAreaPixels.height,
//         0,
//         0,
//         croppedAreaPixels.width,
//         croppedAreaPixels.height
//       );

//       // Convert the canvas to a data URL
//       const croppedImageUrl = canvas.toDataURL("image/jpeg");
//       setCroppedImage(croppedImageUrl); // Update the state with the cropped image
//     };

//     image.onerror = (err) => {
//       console.error("Image loading failed:", err);
//     };
//   };

//   // const ImageSaveHandler = () => {
//   //   if (croppedImage) {
//   //     setSelectImage(croppedImage); // Save the cropped image to the `selectImage` state

//   //   } else {
//   //     console.error("No cropped image available to save.");
//   //   }
//   // };

//   const ImageSaveHandler = async () => {
//     if (!croppedImage) {
//       console.error("No cropped image available to save.");
//       return;
//     }

//     setSelectImage(croppedImage); // Save the cropped image to the `selectImage` state

//     try {
//       const formData = new FormData();
//       formData.append("file", croppedImage); // Use the cropped image file here

//       setLogoUrlStatus("Uploading...");
//       const response = await axios.post(
//         `${apiurl}/admin/v1/media/document`,
//         formData,
//         {
//           headers: {
//             "Content-Type": "multipart/form-data",
//           },
//         }
//       );

//       if (response.status === 200) {
//         setLogoUrlStatus("Upload successful!");
//         console.log("Response Data:", response.data);
//         setLogoUrl(response?.data?.fileUrl); // Set the uploaded file URL
//         setShowImagePopup(false);
//       } else {
//         setLogoUrlStatus("Upload failed. Please try again.");
//       }
//     } catch (error) {
//       console.error("Error uploading document:", error);
//       setLogoUrlStatus("An error occurred. Please try again.");
//     }
//   };

//   // Verification states
//   const [verificationData, setVerificationData] = useState({
//     gst: {
//       number: "",
//       isVerified: false,
//       error: "",
//       document: null,
//     },
//     pan: {
//       number: "",
//       isVerified: false,
//       error: "",
//       document: null,
//     },
//     fssai: {
//       number: "",
//       isVerified: false,
//       error: "",
//       document: null,
//     },
//     trademark: {
//       number: "",
//       isVerified: false,
//       error: "",
//       document: null,
//     },
//   });

//   const handleVerificationInput = (type, value) => {
//     setVerificationData((prev) => ({
//       ...prev,
//       [type]: {
//         ...prev[type],
//         number: value,
//         error: "",
//         isVerified: false,
//       },
//     }));
//   };

//   const handleVerify = (type) => {
//     // Simulate verification API call
//     setTimeout(() => {
//       if (verificationData[type].number.length < 5) {
//         setVerificationData((prev) => ({
//           ...prev,
//           [type]: {
//             ...prev[type],
//             error: "Invalid number format",
//             isVerified: false,
//           },
//         }));
//       } else {
//         setVerificationData((prev) => ({
//           ...prev,
//           [type]: {
//             ...prev[type],
//             error: "",
//             isVerified: true,
//           },
//         }));
//       }
//     }, 1000);
//   };

//   const handleFileUpload = (type, file) => {
//     setVerificationData((prev) => ({
//       ...prev,
//       [type]: {
//         ...prev[type],
//         document: file,
//       },
//     }));
//   };

//   const toggleDrawer = () => {
//     setIsOpen(!isOpen);
//   };
//   const deletePopup = () => {
//     setShowDeleteMemberPopup(!showDeleteMemberPopup);
//   };
//   const handleDelete = () => {
//     setShowDeleteMemberPopup(false);
//   };

//   const [copiedStatus, setCopiedStatus] = useState({
//     url1: false,
//     url2: false,
//     url3: false,
//     url4: false,
//   });

//   const [showAddMemberPopup, setShowAddMemberPopup] = useState(false);
//   const [showDeleteMemberPopup, setShowDeleteMemberPopup] = useState(false);
//   const [formdata, setFormdata] = useState({
//     name: "",
//     email: "",
//     phone: "",
//     role: "",
//     stores: true,
//     products: true,
//     orders: true,
//     settings: true,
//     reports: true,
//     users: true,
//     analytics: true,
//     magento: false,
//     shopify: false,
//     manual: true,
//   });

//   const apiUrl = {
//     url1: "http://example.com/1",
//     url2: "http://example.com/2",
//     url3: "http://example.com/3",
//     url4: "http://example.com/4",
//   };

//   const copyToClipboard = (urlToCopy, key) => {
//     navigator.clipboard
//       .writeText(urlToCopy)
//       .then(() => {
//         setCopiedStatus((prevStatus) => ({
//           ...prevStatus,
//           [key]: true,
//         }));

//         setTimeout(() => {
//           setCopiedStatus((prevStatus) => ({
//             ...prevStatus,
//             [key]: false,
//           }));
//         }, 3000);
//       })
//       .catch((err) => {
//         console.error("Failed to copy: ", err);
//       });
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormdata({ ...formdata, [name]: value });
//   };
//   console.log(formdata);

//   const handleToggleChange = (key) => {
//     setFormdata((prevFormData) => ({
//       ...prevFormData,
//       [key]: !prevFormData[key],
//     }));
//     if (key === "shopify" || key === "magento") {
//       setShowPopup(true);
//       setPopupType(key);
//     }
//   };

//   const TabBarItem = ({ label, isActive, onClick }) => {
//     return (
//       <button
//         className={`md:py-2 px-6 text-xs md:text-base h-10 rounded-md rounded-b-none  ${
//           isActive
//             ? "md:font-semibold bg-zinc-950 text-white "
//             : " text-gray-500 hover:text-black"
//         }`}
//         onClick={onClick}
//       >
//         {label}
//       </button>
//     );
//   };

//   const Content = ({ label, value }) => {
//     return (
//       <div className="grid grid-cols-2 text-xs md:text-base">
//         <p className="font-semibold ">{label}:</p>
//         <p className="text-slate-500">{value}</p>
//       </div>
//     );
//   };

//   const [venderDetails, setVenderDetails] = useState("");
//   let vendorObjId = userData?.vendorDetails?.vendorObjId;
//   const [verifiedPan, setVerifedPan] = useState(false);
//   const [verifiedGst, setVerifedGst] = useState(false);
//   const [gstNumber, setGstNumber] = useState("");
//   const [panNumber, setPanNumber] = useState("");

//   useEffect(() => {
//     setLoading(true);
//     let config = {
//       method: "get",
//       maxBodyLength: Infinity,
//       url: `${apiurl}/api/vendor/get/${vendorObjId}`,
//       headers: {},
//     };

//     axios
//       .request(config)
//       .then((response) => {
//         console.log(JSON.stringify(response.data));
//         setLoading(false);
//         setVenderDetails(response.data);
//         setUpdateDetail(response.data.vendorDetails);
//         // GST Details
//         setGstNumber(response.data.vendorDetails?.gstDetails?.gstNumber);
//         if (response.data.vendorDetails?.gstDetails?.gstNumber) {
//           setVerifedGst(
//             !response.data.vendorDetails?.gstDetails?.gstDocument || false
//           );
//         }
//         // PAN Details
//         setPanNumber(response.data.vendorDetails?.panDetails?.panNumber);
//         if (response.data.vendorDetails?.panDetails?.panNumber) {
//           setVerifedPan(
//             !response.data.vendorDetails?.panDetails?.panDocument || false
//           );
//         }
//       })
//       .catch((error) => {
//         console.log(error);
//         setLoading(false);
//       });
//   }, []);

//   console.log("userData", userData);
//   console.log("venderDetails", venderDetails);

//   //------------------------------------------ Pan DATA Handler -------------------------------------------------------------
//   const [panError, setPanError] = useState("");
//   const [panDocument, setPanDocument] = useState("");

//   const [penDocument, setPenDocument] = useState("");
//   const [panProccessing, setPanProccessing] = useState(false);
//   const [panLoading, setPanLoading] = useState(false);
//   const [panUrlStatus, setPanUrlStatus] = useState("");
//   const [panUrl, setPanUrl] = useState("");

//   console.log("panDocument", panDocument);

//   const panVarificationHandler = () => {
//     setPanProccessing(true);
//     let data = JSON.stringify({
//       pan_number: panNumber,
//     });

//     let config = {
//       method: "post",
//       maxBodyLength: Infinity,
//       url: `${apiurl}/admin/v1/validation/pan/validate`,
//       headers: {
//         "Content-Type": "application/json",
//       },
//       data: data,
//     };

//     axios
//       .request(config)
//       .then((response) => {
//         console.log(JSON.stringify(response.data));
//         if (response.data.success === true) {
//           setVerifedPan(true);
//           setPanError("");
//           setPenDocument(response.data.response.data);
//           setPanProccessing(false);
//         } else {
//           setVerifedPan(false);
//           setPenDocument("");
//           setPanError("Incorrect PAN number");
//           setPanProccessing(false);
//         }
//       })
//       .catch((error) => {
//         setPenDocument("");
//         setPanError("something went wrong");
//         console.log(error);
//         setPanProccessing(false);
//       });
//   };

//   useEffect(() => {
//     if (
//       !updateDetail?.panDetails?.panNumber &&
//       panNumber &&
//       panNumber.length >= 10
//     ) {
//       panVarificationHandler();
//     }
//   }, [panNumber]);

//   const getPanDocumentUrl = async (file) => {
//     if (!file) return;

//     const formData = new FormData();
//     formData.append("file", file);

//     try {
//       setPanUrlStatus("Uploading...");
//       const response = await axios.post(
//         `${apiurl}/admin/v1/media/document`,
//         formData,
//         {
//           headers: {
//             "Content-Type": "multipart/form-data",
//           },
//         }
//       );

//       if (response.status === 200) {
//         setPanUrlStatus("Upload successful!");
//         console.log("Response Data:", response.data);
//         setPanUrl(response?.data?.fileUrl);
//       } else {
//         setPanUrlStatus("Upload failed. Please try again.");
//       }
//     } catch (error) {
//       console.error("Error uploading document:", error);
//       setPanUrlStatus("An error occurred. Please try again.");
//     }
//   };

//   // Trigger upload whenever panDocument changes
//   useEffect(() => {
//     if (panDocument) {
//       getPanDocumentUrl(panDocument);
//     }
//   }, [panDocument]);

//   const PanDocUploadHandler = () => {
//     // Check if panUrl exists
//     if (!panUrl) {
//       console.error("PAN URL is required.");
//       return;
//     }

//     // Set loading state
//     setPanLoading(true);

//     // Ensure panDocument and panNumber are provided
//     if (panDocument && panNumber) {
//       const data = JSON.stringify({
//         vendorObjId: vendorObjId,
//         panNumber: panNumber,
//         panDocument: panUrl,
//       });

//       const config = {
//         method: "post",
//         maxBodyLength: Infinity,
//         url: `${apiurl}/admin/v1/validation/pan/update`,
//         headers: {
//           "Content-Type": "application/json",
//         },
//         data: data,
//       };

//       axios
//         .request(config)
//         .then((response) => {
//           console.log("Response:", response.data);

//           if (response.data.success) {
//             setUpdateDetail(response.data.message?.vendorDetails);
//             setPanLoading(false);
//             setVerifedPan(false);
//           } else {
//             console.warn("PAN update failed:", response.data.message);
//             setPanLoading(false);
//           }
//         })
//         .catch((error) => {
//           setPanLoading(false);
//           console.error("Error during PAN upload:", error.message);
//         });
//     } else {
//       console.warn("PAN Document and PAN Number are required.");
//       setPanLoading(false);
//     }
//   };

//   //------------------------------------------ Document DATA Handler -------------------------------------------------------------
//   const [gstError, setGstError] = useState("");
//   const [gstDocument, setGstDocument] = useState("");
//   const [GstDetails, setGstDetails] = useState("");
//   const [gstProccessing, setGstProccessing] = useState(false);
//   const [gstLoading, setGstLoading] = useState(false);
//   const [gstUrlStatus, setGstUrlStatus] = useState("");
//   const [gstUrl, setGstUrl] = useState("");

//   const gstVarificationHandler = () => {
//     setGstProccessing(true);
//     let data = JSON.stringify({
//       GST: gstNumber,
//     });

//     let config = {
//       method: "post",
//       maxBodyLength: Infinity,
//       url: `${apiurl}/admin/v1/validation/gst/validate`,
//       headers: {
//         "Content-Type": "application/json",
//       },
//       data: data,
//     };

//     axios
//       .request(config)
//       .then((response) => {
//         console.log(JSON.stringify(response.data));
//         if (response.data.success === true) {
//           setGstDetails(response.data.data.data);
//           setVerifedGst(true);
//           setGstError("");
//           setGstProccessing(false);
//         } else {
//           setGstProccessing(false);
//           setVerifedGst(false);
//           setGstError("Incorrect PAN number");
//           setGstDetails("");
//         }
//       })
//       .catch((error) => {
//         setGstError("something went wrong");
//         setGstDetails("");
//         setGstProccessing(false);
//         console.log(error);
//       });
//   };
//   useEffect(() => {
//     if (
//       !updateDetail?.gstDetails?.gstNumber &&
//       gstNumber &&
//       gstNumber.length >= 15
//     ) {
//       gstVarificationHandler();
//     }
//   }, [gstNumber]);

//   const getGstDocumentUrl = async (file) => {
//     if (!file) return;

//     const formData = new FormData();
//     formData.append("file", file);

//     try {
//       setGstUrlStatus("Uploading...");
//       const response = await axios.post(
//         `${apiurl}/admin/v1/media/document`,
//         formData,
//         {
//           headers: {
//             "Content-Type": "multipart/form-data",
//           },
//         }
//       );

//       if (response.status === 200) {
//         setGstUrlStatus("Upload successful!");
//         console.log("Response Data:", response.data);
//         setGstUrl(response?.data?.fileUrl);
//       } else {
//         setGstUrlStatus("Upload failed. Please try again.");
//       }
//     } catch (error) {
//       console.error("Error uploading document:", error);
//       setGstUrlStatus("An error occurred. Please try again.");
//     }
//   };

//   // Trigger upload whenever panDocument changes
//   useEffect(() => {
//     if (gstDocument) {
//       getGstDocumentUrl(gstDocument);
//     }
//   }, [gstDocument]);

//   const GstDocUploadHandler = () => {
//     setGstLoading(true);
//     if (gstDocument && gstNumber && gstUrl) {
//       let data = JSON.stringify({
//         vendorObjId: vendorObjId,
//         gstNumber: gstNumber,
//         gstDocument: gstUrl,
//       });

//       let config = {
//         method: "post",
//         maxBodyLength: Infinity,
//         url: `${apiurl}/admin/v1/validation/gst/update`,
//         headers: {
//           "Content-Type": "application/json",
//         },
//         data: data,
//       };

//       axios
//         .request(config)
//         .then((response) => {
//           console.log(JSON.stringify("GSTNUMBER", response.data));
//           if (response.data.success === true) {
//             setUpdateDetail(response.data?.message?.vendorDetails);
//             setGstLoading(false);

//             setVerifedGst(false);
//           }
//         })
//         .catch((error) => {
//           setVerifedGst(false);

//           console.log(error);
//         });
//     }
//   };

//   useEffect(() => {
//     setTimeout(() => {
//       setGstError("");
//       setPanError();
//     }, 5000);
//   }, [panError, gstError]);

//   return (
//     <Layout>
//       <Container>
//         {loading === true ? (
//           <InfiLoader maintext="Fetching Documents..." />
//         ) : (
//           <div className="flex flex-wrap justify-between w-full h-full ">
//             <div className="flex flex-col  px-2 py-2 w-[100%] h-[100%] overflow-scroll">
//               <div className="h-[80%]">
//                 {activeSection === "documentation" && (
//                   <div className="flex flex-col gap-6 mt-10">
//                     {/* GST Verification */}
//                     <div
//                       className={`bg-white p-2 md:p-6 rounded-lg shadow-sm border`}
//                     >
//                       <div className="flex  gap-2">
//                         <h3 className="text-sm md:text-lg font-semibold mb-4">
//                           GST Verification
//                         </h3>
//                         {updateDetail?.gstDetails?.gstDocument && (
//                           <div className="">
//                             {updateDetail?.verificationDetails
//                               ?.isGstVerified === false &&
//                             updateDetail?.gstDetails?.gstDocument ? (
//                               <span className="bg-yellow-50  border border-yellow-300 px-2 text-xs py-0.5 text-yellow-800  rounded ">
//                                 Pending
//                               </span>
//                             ) : updateDetail?.verificationDetails
//                                 ?.isGstVerified === true &&
//                               updateDetail?.gstDetails?.gstDocument ? (
//                               <span className="bg-green-50  border border-green-300 px-2 text-xs py-0.5 text-green-800 rounded">
//                                 Verified
//                               </span>
//                             ) : (
//                               ""
//                             )}
//                           </div>
//                         )}
//                       </div>

//                       <div className="flex gap-4 items-start w-full">
//                         <div className="w-full">
//                           <div className="flex">
//                             <div className="bg-zinc-50  px-2 text-xs py-0.5 text-slate-400 rounded">
//                               {GstDetails?.legal_name}
//                             </div>
//                           </div>
//                           <div className="flex items-center justify-between w-full p-2 border rounded">
//                             <input
//                               type="text"
//                               disabled={updateDetail?.gstDetails?.gstNumber}
//                               placeholder="Enter GST Number"
//                               className={`px-2 w-full outline-none  md:text-base text-xs bg-white ${
//                                 updateDetail?.gstDetails?.gstNumber
//                                   ? "text-zinc-400"
//                                   : "text-black"
//                               } `}
//                               value={gstNumber}
//                               maxLength={15}
//                               onChange={(e) =>
//                                 setGstNumber(e.target.value.slice(0, 15))
//                               }
//                             />
//                             {gstProccessing && <loader.staggerCircle />}
//                           </div>
//                           {gstError && (
//                             <p className="text-red-500 text-sm mt-1">
//                               {gstError}
//                             </p>
//                           )}
//                         </div>
//                       </div>
//                       {verifiedGst && (
//                         <div className="mt-4">
//                           <div className="flex items-center gap-2 text-green-600 mb-3">
//                             <TiTick size={20} />
//                             <span>Verified Successfully</span>
//                           </div>
//                           <div className="flex justify-between">
//                             <div className="flex items-center gap-4">
//                               <input
//                                 type="file"
//                                 id="gst-doc"
//                                 className="hidden"
//                                 onChange={(e) =>
//                                   setGstDocument(e.target.files[0])
//                                 }
//                               />
//                               <label
//                                 htmlFor="gst-doc"
//                                 className="flex items-center gap-2 cursor-pointer px-4 py-2 bg-gray-100 rounded hover:bg-gray-200"
//                               >
//                                 <FiUpload />
//                                 <span>Upload Document</span>
//                               </label>

//                               {gstDocument && (
//                                 <span className="text-sm text-gray-600">
//                                   {gstUrlStatus && gstUrlStatus}
//                                   {/* {gstDocument?.name} */}
//                                 </span>
//                               )}
//                             </div>
//                             <BlackButton
//                               loading={gstLoading}
//                               title="Update"
//                               handleSubmit={GstDocUploadHandler}
//                               disabled={gstUrl === ""}
//                             />
//                           </div>
//                         </div>
//                       )}
//                     </div>

//                     {/* PAN Verification */}
//                     <div
//                       className={`bg-white p-2 md:p-6 rounded-lg shadow-sm border  `}
//                     >
//                       <div className="flex  gap-2">
//                         <h3 className="text-sm md:text-lg font-semibold mb-4">
//                           PAN Verification
//                         </h3>
//                         {updateDetail?.panDetails?.panDocument && (
//                           <div className="">
//                             {updateDetail?.verificationDetails
//                               ?.isGstVerified === false &&
//                             updateDetail?.panDetails?.panDocument ? (
//                               <span className="bg-yellow-50  border border-yellow-300 px-2 text-xs py-0.5 text-yellow-800  rounded ">
//                                 Pending
//                               </span>
//                             ) : updateDetail?.verificationDetails
//                                 ?.isGstVerified === true &&
//                               updateDetail?.panDetails?.panDocument ? (
//                               <span className="bg-green-50  border border-green-300 px-2 text-xs py-0.5 text-green-800 rounded">
//                                 Verified
//                               </span>
//                             ) : (
//                               ""
//                             )}
//                           </div>
//                         )}
//                       </div>
//                       <div className="flex gap-4 items-start">
//                         <div className="flex-1">
//                           <div className="flex">
//                             <div className="bg-zinc-50  px-2 text-xs py-0.5 text-slate-400">
//                               {penDocument?.full_name}
//                             </div>
//                           </div>
//                           <div className="flex items-center justify-between w-full p-2 border rounded">
//                             <input
//                               type="text"
//                               placeholder="Enter PAN Number"
//                               className={`px-2 w-full outline-none  md:text-base text-xs bg-white ${
//                                 updateDetail?.panDetails?.panNumber
//                                   ? "text-zinc-400"
//                                   : "text-black"
//                               } `}
//                               value={panNumber}
//                               maxLength={10} // This limits the input to 10 characters
//                               onChange={(e) =>
//                                 setPanNumber(e.target.value.slice(0, 10))
//                               }
//                               disabled={updateDetail?.panDetails?.panNumber}
//                             />
//                             {panProccessing && <loader.staggerCircle />}
//                           </div>
//                           {panError && (
//                             <p className="text-red-500 text-sm mt-1">
//                               {panError}
//                             </p>
//                           )}
//                         </div>
//                       </div>
//                       {verifiedPan && (
//                         <div className="mt-4">
//                           <div className="flex items-center gap-2 text-green-600 mb-3">
//                             <TiTick size={20} />
//                             <span>Verified Successfully</span>
//                           </div>
//                           <div className="flex justify-between">
//                             <div className="flex items-center gap-4">
//                               <input
//                                 type="file"
//                                 id="pan-doc"
//                                 className="hidden"
//                                 onChange={(e) =>
//                                   setPanDocument(e.target.files[0])
//                                 }
//                               />
//                               <label
//                                 htmlFor="pan-doc"
//                                 className="flex items-center gap-2 cursor-pointer px-4 py-2 bg-gray-100 rounded hover:bg-gray-200"
//                               >
//                                 <FiUpload />
//                                 <span>Upload Document</span>
//                               </label>
//                               {panDocument && (
//                                 <span className="text-sm text-gray-600">
//                                   {panUrlStatus && panUrlStatus}
//                                   {/* {panDocument.name} */}
//                                 </span>
//                               )}
//                             </div>
//                             <BlackButton
//                               loading={panLoading}
//                               title="Update"
//                               handleSubmit={PanDocUploadHandler}
//                               disabled={panUrl === ""}
//                             />
//                           </div>
//                         </div>
//                       )}
//                     </div>
//                     {/* Profile Image Upload */}
//                     {vendor?.vendorDetails?.logo?.upload === true ? (
//                       <div
//                         className={`bg-white p-2 flex justify-between items-center md:p-6 rounded-lg shadow-sm border  `}
//                       >
//                         <img
//                           className="h-12"
//                           src={vendor?.vendorDetails?.logo?.url}
//                         />
//                         <button
//                           className="text-xs border text-zinc-700 bg-zinc-50 px-2 rounded-md flex items-center gap-1"
//                           onClick={() => setShowImagePopup(true)}
//                         >
//                           <LiaRedoAltSolid /> Replace
//                         </button>
//                       </div>
//                     ) : (
//                       <div>
//                         {" "}
//                         <div
//                           className={`bg-white p-2 md:p-6 rounded-lg shadow-sm border  `}
//                         >
//                           <div className="flex  gap-2">
//                             <h3 className="text-sm md:text-lg font-semibold mb-4">
//                               Upload Logo
//                             </h3>
//                           </div>
//                           {
//                             <div className="mt-4">
//                               <div className="flex justify-between">
//                                 <div
//                                   className="flex items-center gap-4"
//                                   onClick={() => setShowImagePopup(true)}
//                                 >
//                                   <label
//                                     htmlFor="profileImage"
//                                     className="flex items-center gap-2 cursor-pointer px-4 py-2 bg-gray-100 rounded hover:bg-gray-200"
//                                   >
//                                     <FiUpload />
//                                     <span>Upload</span>
//                                   </label>
//                                 </div>
//                                 <BlackButton title="Update" />
//                               </div>
//                             </div>
//                           }
//                         </div>
//                       </div>
//                     )}
//                   </div>
//                 )}
//                 {activeSection === "api" && (
//                   <div className="flex flex-col md:gap-8 mt-10">
//                     <div className="text-gray-700 bg-slate-50 border-2 border-slate-200 px-2 py-2 md:px-6 md:py-4 rounded-lg w-full">
//                       <div className="flex flex-col md:flex-row items-center space-y-2 md:space-y-0 space-x-4">
//                         <div>
//                           <label
//                             htmlFor="apiName"
//                             className="block text-gray-700 text-sm font-medium md:min-w-[120px]"
//                           >
//                             API Name
//                           </label>
//                         </div>
//                         <div className="flex flex-grow">
//                           <input
//                             type="text"
//                             id="apiName"
//                             className="flex-grow border border-slate-300 rounded-md py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:ring-2 focus:ring-slate-500 focus:border-slate-500"
//                             placeholder="Enter API name"
//                           />
//                         </div>
//                         <div>
//                           <button className="bg-slate-600 text-white text-xs md:text-base px-2 py-1 md:px-4 md:py-2 rounded-md hover-bg-slate-700 focus:outline-none focus:ring-2 focus:ring-slate-500">
//                             Generate API
//                           </button>
//                         </div>
//                       </div>
//                     </div>

//                     <div className="text-gray-700 border-2 border-slate-200 px-2 py-2 md:px-6 md:py-4 rounded-lg">
//                       <div>
//                         <h4 className="text-base font-medium text-slate-500 pl-6">
//                           Your APIs
//                         </h4>
//                       </div>
//                       <div className="flex flex-col gap-6 ">
//                         <div className="text-gray-700 bg-slate-50 border-2 border-slate-200 px-2 py-2 md:px-6 md:py-4 rounded-lg w-full">
//                           <div className="flex justify-between items-center mb-2">
//                             <span className="font-semibold">API Key 1</span>
//                             <button
//                               onClick={() =>
//                                 copyToClipboard(apiUrl.url1, "url1")
//                               }
//                               className="bg-slate-600 text-white px-4 py-1 rounded hover-bg-slate-700 text-xs md:text-sm"
//                             >
//                               {copiedStatus.url1 ? "Copied" : "Copy"}
//                             </button>
//                           </div>
//                           <div className="flex justify-between items-center">
//                             <span className="text-sm text-gray-600">
//                               {apiUrl.url2}
//                             </span>
//                             <button
//                               onClick={() =>
//                                 copyToClipboard(apiUrl.url2, "url2")
//                               }
//                               className="bg-slate-600 text-white px-2 md:px-4 py-1 rounded hover-bg-slate-700 text-xs md:text-sm"
//                             >
//                               {copiedStatus.url2 ? "Copied" : "Copy URL"}
//                             </button>
//                           </div>
//                         </div>

//                         <div className="text-gray-700 bg-slate-50 border-2 border-slate-200 px-2 py-2 md:px-6 md:py-4 rounded-lg w-full">
//                           <div className="flex justify-between items-center mb-2">
//                             <span className="font-semibold">API Key 2</span>
//                             <button
//                               onClick={() =>
//                                 copyToClipboard(apiUrl.url3, "url3")
//                               }
//                               className="bg-slate-600 text-white px-4 py-1 rounded hover-bg-slate-700 text-sm"
//                             >
//                               {copiedStatus.url3 ? "Copied" : "Copy"}
//                             </button>
//                           </div>
//                           <div className="flex justify-between items-center">
//                             <span className="text-sm text-gray-600">
//                               {/* https://api.example.com/v1/key2 */}
//                               {apiUrl.url4}
//                             </span>
//                             <button
//                               onClick={() =>
//                                 copyToClipboard(apiUrl.url4, "url4")
//                               }
//                               className="bg-slate-600 text-white px-2 md:px-4 py-1 rounded hover-bg-slate-700 text-xs md:text-sm"
//                             >
//                               {copiedStatus.url4 ? "Copied" : "Copy URL"}
//                             </button>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 )}
//                 {activeSection === "permissions" && (
//                   <div className="flex flex-col gap-2 mt-10 bg-zinc-50 p-4  rounded-md">
//                     <div className="text-gray-700   py-3 border-b">
//                       <div className="flex justify-between">
//                         <label
//                           htmlFor="gupshup"
//                           className="block text-gray-700 text-sm font-medium md:min-w-[120px]"
//                         >
//                           Gupshup
//                         </label>
//                         <div
//                           onClick={() => handleToggleChange("gupshup")}
//                           className={`w-12 h-6 flex items-center rounded-full p-1 cursor-pointer ${
//                             formdata.gupshup ? "bg-gray-500" : "bg-gray-300"
//                           }`}
//                         >
//                           <div
//                             className={`bg-white w-3 h-3 lg:w-4 lg:h-4 rounded-full shadow-md transform ${
//                               formdata.gupshup ? "translate-x-6" : ""
//                             } transition-transform`}
//                           />
//                         </div>
//                       </div>
//                     </div>
//                     <div className="text-gray-700   py-3 border-b">
//                       <div className="flex justify-between">
//                         <label
//                           htmlFor="shopify"
//                           className="block text-gray-700 text-sm font-medium md:min-w-[120px]"
//                         >
//                           Shopify
//                         </label>
//                         <div
//                           onClick={() => handleToggleChange("shopify")}
//                           className={`w-12 h-6 flex items-center rounded-full p-1 cursor-pointer ${
//                             formdata.shopify ? "bg-gray-500" : "bg-gray-300"
//                           }`}
//                         >
//                           <div
//                             className={`bg-white w-3 h-3 lg:w-4 lg:h-4 rounded-full shadow-md transform ${
//                               formdata.shopify ? "translate-x-6" : ""
//                             } transition-transform`}
//                           />
//                         </div>
//                       </div>
//                     </div>
//                     <div className="text-gray-700   py-3 rounded-lg">
//                       <div className="flex justify-between">
//                         <label
//                           htmlFor="manual"
//                           className="block text-gray-700 text-sm font-medium md:min-w-[120px]"
//                         >
//                           Manual
//                         </label>
//                         <div
//                           onClick={() => handleToggleChange("manual")}
//                           className={`w-12 h-6 flex items-center rounded-full p-1 cursor-pointer ${
//                             formdata.manual ? "bg-gray-500" : "bg-gray-300"
//                           }`}
//                         >
//                           <div
//                             className={`bg-white w-3 h-3 lg:w-4 lg:h-4 rounded-full shadow-md transform ${
//                               formdata.manual ? "translate-x-6" : ""
//                             } transition-transform`}
//                           />
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 )}
//               </div>
//             </div>
//           </div>
//         )}
//         {showImagePopup && (
//           <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
//             <div className="relative bg-white rounded-lg shadow-lg w-[90%] max-w-2xl">
//               {/* <img src={croppedImage} alt="e234"/> */}
//               <div className="flex justify-between items-center px-4 py-2 border-b">
//                 <h2 className="text-lg font-bold">Crop Your Image</h2>
//                 <button onClick={onClosePopup} className="text-gray-500">
//                   <IoClose size={24} />
//                 </button>
//               </div>
//               <div className="p-4">
//                 {!selectedImage ? (
//                   <div className="flex flex-col items-center justify-center border-2 border-dashed border-gray-300 p-6 rounded-md">
//                     <label
//                       htmlFor="file-input"
//                       className="text-blue-500 cursor-pointer underline"
//                     >
//                       Select Image
//                     </label>
//                     <input
//                       id="file-input"
//                       type="file"
//                       accept="image/*"
//                       onChange={handleImageChange}
//                       className="hidden"
//                     />
//                     <p className="mt-2 text-gray-500">
//                       or drag and drop your image
//                     </p>
//                   </div>
//                 ) : (
//                   <div className="relative w-full h-64">
//                     <Cropper
//                       image={selectedImage}
//                       crop={crop}
//                       zoom={zoom}
//                       aspect={3.3}
//                       onCropChange={setCrop}
//                       onZoomChange={setZoom}
//                       onCropComplete={onCropComplete}
//                     />
//                   </div>
//                 )}
//               </div>

//               <div className="flex justify-between items-center px-4 py-2 border-t">
//                 <span className="text-sm text-gray-500">
//                   Selected size: 3.3
//                 </span>
//                 <button
//                   onClick={ImageSaveHandler}
//                   className="bg-green-500 text-white px-4 py-2 rounded-md"
//                 >
//                   Save Cropped Image
//                 </button>
//               </div>
//               {/* <img src={selectImage} /> */}
//             </div>
//           </div>
//         )}
//       </Container>
//       {showPopup && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
//           <div className="bg-white p-8 rounded-lg">
//             <h2 className="text-2xl font-bold mb-4">
//               {popupType.charAt(0).toUpperCase() + popupType.slice(1)}{" "}
//               Integration
//             </h2>
//             <input
//               type="text"
//               placeholder="API Endpoint"
//               className="w-full p-2 mb-4 border rounded"
//             />
//             <input
//               type="text"
//               placeholder="Access Token"
//               className="w-full p-2 mb-4 border rounded"
//             />
//             <input
//               type="text"
//               placeholder="Secret Key"
//               className="w-full p-2 mb-4 border rounded"
//             />
//             <input
//               type="text"
//               placeholder="API Key"
//               className="w-full p-2 mb-4 border rounded"
//             />
//             <input
//               type="text"
//               placeholder="Version"
//               className="w-full p-2 mb-4 border rounded"
//             />
//             <div className="flex justify-end">
//               <button
//                 onClick={() => setShowPopup(false)}
//                 className="bg-gray-300 text-gray-800 px-4 py-2 rounded mr-2"
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={() => setShowPopup(false)}
//                 className="bg-blue-500 text-white px-4 py-2 rounded"
//               >
//                 Save
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </Layout>
//   );
// }

// export default Documents;

import React, { useState, useEffect, useCallback } from "react";
import Layout, { Container } from "../components/layout";
import { FiUpload } from "react-icons/fi";
import { TiTick } from "react-icons/ti";
import { BlackButton } from "../components/buttonContainer";
import { useUser } from "../config/userProvider";
import axios from "axios";
import { apiurl } from "../config/config";
// import { AiTwotoneEdit } from "react-icons/ai";
// import { RiDeleteBin6Fill } from "react-icons/ri";
// import InputContainer from "../components/inputContainer";
// import { RxCross2 } from "react-icons/rx";
// import { InfiLoader } from "../components/loader";
// import { LiaRedoAltSolid } from "react-icons/lia";
import loader, { InfiLoader } from "../components/loader";
import { useTheme } from "../config/themeContext";

function Documents() {
  const { userData } = useUser();
  const { vendor } = useTheme();
  // const [isOpen, setIsOpen] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [popupType, setPopupType] = useState("");
  const [activeSection, setActiveSection] = useState("documentation");
  const [updateDetail, setUpdateDetail] = useState("");
  const [loading, setLoading] = useState(false);
  const [logoUrl, setLogoUrl] = useState("");
  const [logoUrlStatus, setLogoUrlStatus] = useState("");

  const handleImageChange = async (e) => {
    const file = e.target.files[0];
    if (!file) {
      console.error("No image selected.");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("file", file);

      setLogoUrlStatus("Uploading...");
      const response = await axios.post(
        `${apiurl}/admin/v1/media/document`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      if (response.status === 200) {
        setLogoUrlStatus("Upload successful!");
        console.log("Response Data:", response.data);
        setLogoUrl(response?.data?.fileUrl); // Set the uploaded file URL
      } else {
        setLogoUrlStatus("Upload failed. Please try again.");
      }
    } catch (error) {
      console.error("Error uploading document:", error);
      setLogoUrlStatus("An error occurred. Please try again.");
    }
  };

  const updateVendorLogo = async () => {
    if (!logoUrl) {
      console.error("No logo URL available to update.");
      setLogoUrlStatus("Please upload an image first.");
      return;
    }

    try {
      const data = JSON.stringify({
        vendorObjId: userData?.vendorDetails?.vendorObjId,
        logo: logoUrl,
      });

      const config = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${apiurl}/admin/v1/vendor/update-logo`,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };

      const response = await axios.request(config);
      if (response.data.success) {
        setUpdateDetail(response.data.message?.vendorDetails);
        setLogoUrlStatus("Logo updated successfully!");
      } else {
        console.warn("Logo update failed:", response.data.message);
        setLogoUrlStatus("Failed to update logo.");
      }
    } catch (error) {
      console.error("Error updating logo:", error.message);
      setLogoUrlStatus("An error occurred while updating logo.");
    }
  };

  // Verification states
  // const [verificationData, setVerificationData] = useState({
  //   gst: { number: "", isVerified: false, error: "", document: null },
  //   pan: { number: "", isVerified: false, error: "", document: null },
  //   fssai: { number: "", isVerified: false, error: "", document: null },
  //   trademark: { number: "", isVerified: false, error: "", document: null },
  // });

  // const handleVerificationInput = (type, value) => {
  //   setVerificationData((prev) => ({
  //     ...prev,
  //     [type]: { ...prev[type], number: value, error: "", isVerified: false },
  //   }));
  // };

  // const handleVerify = (type) => {
  //   setTimeout(() => {
  //     if (verificationData[type].number.length < 5) {
  //       setVerificationData((prev) => ({
  //         ...prev,
  //         [type]: { ...prev[type], error: "Invalid number format", isVerified: false },
  //       }));
  //     } else {
  //       setVerificationData((prev) => ({
  //         ...prev,
  //         [type]: { ...prev[type], error: "", isVerified: true },
  //       }));
  //     }
  //   }, 1000);
  // };

  // const handleFileUpload = (type, file) => {
  //   setVerificationData((prev) => ({
  //     ...prev,
  //     [type]: { ...prev[type], document: file },
  //   }));
  // };

  // const toggleDrawer = () => {
  //   setIsOpen(!isOpen);
  // };

  // const [showAddMemberPopup, setShowAddMemberPopup] = useState(false);
  // const [showDeleteMemberPopup, setShowDeleteMemberPopup] = useState(false);
  const [formdata, setFormdata] = useState({
    name: "",
    email: "",
    phone: "",
    role: "",
    stores: true,
    products: true,
    orders: true,
    settings: true,
    reports: true,
    users: true,
    analytics: true,
    magento: false,
    shopify: false,
    manual: true,
  });

  const apiUrl = {
    url1: "http://example.com/1",
    url2: "http://example.com/2",
    url3: "http://example.com/3",
    url4: "http://example.com/4",
  };

  const copyToClipboard = (urlToCopy, key) => {
    navigator.clipboard
      .writeText(urlToCopy)
      .then(() => {
        setCopiedStatus((prevStatus) => ({ ...prevStatus, [key]: true }));
        setTimeout(() => {
          setCopiedStatus((prevStatus) => ({ ...prevStatus, [key]: false }));
        }, 3000);
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
  };

  const [copiedStatus, setCopiedStatus] = useState({
    url1: false,
    url2: false,
    url3: false,
    url4: false,
  });

  // const handleInputChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormdata({ ...formdata, [name]: value });
  // };

  const handleToggleChange = (key) => {
    setFormdata((prevFormData) => ({
      ...prevFormData,
      [key]: !prevFormData[key],
    }));
    if (key === "shopify" || key === "magento") {
      setShowPopup(true);
      setPopupType(key);
    }
  };

  const TabBarItem = ({ label, isActive, onClick }) => {
    return (
      <button
        className={`md:py-2 px-6 text-xs md:text-base h-10 rounded-md rounded-b-none ${
          isActive
            ? "md:font-semibold bg-zinc-950 text-white "
            : " text-gray-500 hover:text-black"
        }`}
        onClick={onClick}
      >
        {label}
      </button>
    );
  };

  // const Content = ({ label, value }) => {
  //   return (
  //     <div className="grid grid-cols-2 text-xs md:text-base">
  //       <p className="font-semibold">{label}:</p>
  //       <p className="text-slate-500">{value}</p>
  //     </div>
  //   );
  // };

  // const [venderDetails, setVenderDetails] = useState("");
  let vendorObjId = userData?.vendorDetails?.vendorObjId;
  const [verifiedPan, setVerifedPan] = useState(false);
  const [verifiedGst, setVerifedGst] = useState(false);
  const [gstNumber, setGstNumber] = useState("");
  const [panNumber, setPanNumber] = useState("");

  // useEffect(() => {
  //   setLoading(true);
  //   let config = {
  //     method: "get",
  //     maxBodyLength: Infinity,
  //     url: `${apiurl}/api/vendor/get/${vendorObjId}`,
  //     headers: {},
  //   };

  //   axios
  //     .request(config)
  //     .then((response) => {
  //       console.log(JSON.stringify(response.data));
  //       setLoading(false);
  //       // setVenderDetails(response.data);
  //       setUpdateDetail(response.data.vendorDetails);
  //       setGstNumber(response.data.vendorDetails?.gstDetails?.gstNumber);
  //       if (response.data.vendorDetails?.gstDetails?.gstNumber) {
  //         setVerifedGst(
  //           !response.data.vendorDetails?.gstDetails?.gstDocument || false,
  //         );
  //       }
  //       setPanNumber(response.data.vendorDetails?.panDetails?.panNumber);
  //       if (response.data.vendorDetails?.panDetails?.panNumber) {
  //         setVerifedPan(
  //           !response.data.vendorDetails?.panDetails?.panDocument || false,
  //         );
  //       }
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //       setLoading(false);
  //     });
  // }, []);

  useEffect(() => {
    if (!vendorObjId) return;

    setLoading(true);

    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${apiurl}/api/vendor/get/${vendorObjId}`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        console.log(response.data);

        setLoading(false);
        setUpdateDetail(response.data.vendorDetails);

        setGstNumber(response.data.vendorDetails?.gstDetails?.gstNumber);

        if (response.data.vendorDetails?.gstDetails?.gstNumber) {
          setVerifedGst(
            !response.data.vendorDetails?.gstDetails?.gstDocument || false,
          );
        }

        setPanNumber(response.data.vendorDetails?.panDetails?.panNumber);

        if (response.data.vendorDetails?.panDetails?.panNumber) {
          setVerifedPan(
            !response.data.vendorDetails?.panDetails?.panDocument || false,
          );
        }
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  }, [vendorObjId]);

  //------------------------------------------ Pan DATA Handler -------------------------------------------------------------
  const [panError, setPanError] = useState("");
  const [panDocument, setPanDocument] = useState("");
  const [penDocument, setPenDocument] = useState("");
  const [panProccessing, setPanProccessing] = useState(false);
  const [panLoading, setPanLoading] = useState(false);
  const [panUrlStatus, setPanUrlStatus] = useState("");
  const [panUrl, setPanUrl] = useState("");

  // const panVarificationHandler = () => {
  //   setPanProccessing(true);
  //   let data = JSON.stringify({ pan_number: panNumber });

  //   let config = {
  //     method: "post",
  //     maxBodyLength: Infinity,
  //     url: `${apiurl}/admin/v1/validation/pan/validate`,
  //     headers: { "Content-Type": "application/json" },
  //     data: data,
  //   };

  //   axios
  //     .request(config)
  //     .then((response) => {
  //       console.log(JSON.stringify(response.data));
  //       if (response.data.success === true) {
  //         setVerifedPan(true);
  //         setPanError("");
  //         setPenDocument(response.data.response.data);
  //         setPanProccessing(false);
  //       } else {
  //         setVerifedPan(false);
  //         setPenDocument("");
  //         setPanError("Incorrect PAN number");
  //         setPanProccessing(false);
  //       }
  //     })
  //     .catch((error) => {
  //       setPenDocument("");
  //       setPanError("something went wrong");
  //       console.log(error);
  //       setPanProccessing(false);
  //     });
  // };

  // useEffect(() => {
  //   if (
  //     !updateDetail?.panDetails?.panNumber &&
  //     panNumber &&
  //     panNumber.length >= 10
  //   ) {
  //     panVarificationHandler();
  //   }
  // }, [panNumber]);

  const panVarificationHandler = useCallback(() => {
    setPanProccessing(true);
    let data = JSON.stringify({ pan_number: panNumber });

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${apiurl}/admin/v1/validation/pan/validate`,
      headers: { "Content-Type": "application/json" },
      data: data,
    };

    axios
      .request(config)
      .then((response) => {
        if (response.data.success === true) {
          setVerifedPan(true);
          setPanError("");
          setPenDocument(response.data.response.data);
        } else {
          setVerifedPan(false);
          setPenDocument("");
          setPanError("Incorrect PAN number");
        }
        setPanProccessing(false);
      })
      .catch((error) => {
        setPenDocument("");
        setPanError("something went wrong");
        console.log(error);
        setPanProccessing(false);
      });
  }, [panNumber]);

  useEffect(() => {
    if (
      !updateDetail?.panDetails?.panNumber &&
      panNumber &&
      panNumber.length >= 10
    ) {
      panVarificationHandler();
    }
  }, [panNumber, updateDetail?.panDetails?.panNumber, panVarificationHandler]);

  const getPanDocumentUrl = async (file) => {
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file);

    try {
      setPanUrlStatus("Uploading...");
      const response = await axios.post(
        `${apiurl}/admin/v1/media/document`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } },
      );

      if (response.status === 200) {
        setPanUrlStatus("Upload successful!");
        console.log("Response Data:", response.data);
        setPanUrl(response?.data?.fileUrl);
      } else {
        setPanUrlStatus("Upload failed. Please try again.");
      }
    } catch (error) {
      console.error("Error uploading document:", error);
      setPanUrlStatus("An error occurred. Please try again.");
    }
  };

  useEffect(() => {
    if (panDocument) {
      getPanDocumentUrl(panDocument);
    }
  }, [panDocument]);

  const PanDocUploadHandler = () => {
    if (!panUrl) {
      console.error("PAN URL is required.");
      return;
    }

    setPanLoading(true);

    if (panDocument && panNumber) {
      const data = JSON.stringify({
        vendorObjId: vendorObjId,
        panNumber: panNumber,
        panDocument: panUrl,
      });

      const config = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${apiurl}/admin/v1/validation/pan/update`,
        headers: { "Content-Type": "application/json" },
        data: data,
      };

      axios
        .request(config)
        .then((response) => {
          console.log("Response:", response.data);
          if (response.data.success) {
            setUpdateDetail(response.data.message?.vendorDetails);
            setPanLoading(false);
            setVerifedPan(false);
          } else {
            console.warn("PAN update failed:", response.data.message);
            setPanLoading(false);
          }
        })
        .catch((error) => {
          setPanLoading(false);
          console.error("Error during PAN upload:", error.message);
        });
    } else {
      console.warn("PAN Document and PAN Number are required.");
      setPanLoading(false);
    }
  };

  //------------------------------------------ Document DATA Handler -------------------------------------------------------------
  const [gstError, setGstError] = useState("");
  const [gstDocument, setGstDocument] = useState("");
  const [GstDetails, setGstDetails] = useState("");
  const [gstProccessing, setGstProccessing] = useState(false);
  const [gstLoading, setGstLoading] = useState(false);
  const [gstUrlStatus, setGstUrlStatus] = useState("");
  const [gstUrl, setGstUrl] = useState("");

  // const gstVarificationHandler = () => {
  //   setGstProccessing(true);
  //   let data = JSON.stringify({ GST: gstNumber });

  //   let config = {
  //     method: "post",
  //     maxBodyLength: Infinity,
  //     url: `${apiurl}/admin/v1/validation/gst/validate`,
  //     headers: { "Content-Type": "application/json" },
  //     data: data,
  //   };

  //   axios
  //     .request(config)
  //     .then((response) => {
  //       console.log(JSON.stringify(response.data));
  //       if (response.data.success === true) {
  //         setGstDetails(response.data.data.data);
  //         setVerifedGst(true);
  //         setGstError("");
  //         setGstProccessing(false);
  //       } else {
  //         setGstProccessing(false);
  //         setVerifedGst(false);
  //         setGstError("Incorrect GST number");
  //         setGstDetails("");
  //       }
  //     })
  //     .catch((error) => {
  //       setGstError("something went wrong");
  //       setGstDetails("");
  //       setGstProccessing(false);
  //       console.log(error);
  //     });
  // };

  // useEffect(() => {
  //   if (
  //     !updateDetail?.gstDetails?.gstNumber &&
  //     gstNumber &&
  //     gstNumber.length >= 15
  //   ) {
  //     gstVarificationHandler();
  //   }
  // }, [gstNumber]);

  const gstVarificationHandler = useCallback(() => {
    setGstProccessing(true);

    let data = JSON.stringify({ GST: gstNumber });

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${apiurl}/admin/v1/validation/gst/validate`,
      headers: { "Content-Type": "application/json" },
      data: data,
    };

    axios
      .request(config)
      .then((response) => {
        if (response.data.success === true) {
          setGstDetails(response.data.data.data);
          setVerifedGst(true);
          setGstError("");
        } else {
          setVerifedGst(false);
          setGstError("Incorrect GST number");
          setGstDetails("");
        }
        setGstProccessing(false);
      })
      .catch((error) => {
        setGstError("something went wrong");
        setGstDetails("");
        setGstProccessing(false);
        console.log(error);
      });
  }, [gstNumber]);

  useEffect(() => {
    if (!gstNumber || gstNumber.length < 15) return;
    if (updateDetail?.gstDetails?.gstNumber) return;

    gstVarificationHandler();
  }, [gstNumber, updateDetail?.gstDetails?.gstNumber, gstVarificationHandler]);

  const getGstDocumentUrl = async (file) => {
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file);

    try {
      setGstUrlStatus("Uploading...");
      const response = await axios.post(
        `${apiurl}/admin/v1/media/document`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } },
      );

      if (response.status === 200) {
        setGstUrlStatus("Upload successful!");
        console.log("Response Data:", response.data);
        setGstUrl(response?.data?.fileUrl);
      } else {
        setGstUrlStatus("Upload failed. Please try again.");
      }
    } catch (error) {
      console.error("Error uploading document:", error);
      setGstUrlStatus("An error occurred. Please try again.");
    }
  };

  useEffect(() => {
    if (gstDocument) {
      getGstDocumentUrl(gstDocument);
    }
  }, [gstDocument]);

  const GstDocUploadHandler = () => {
    setGstLoading(true);
    if (gstDocument && gstNumber && gstUrl) {
      let data = JSON.stringify({
        vendorObjId: vendorObjId,
        gstNumber: gstNumber,
        gstDocument: gstUrl,
      });

      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${apiurl}/admin/v1/validation/gst/update`,
        headers: { "Content-Type": "application/json" },
        data: data,
      };

      axios
        .request(config)
        .then((response) => {
          console.log(JSON.stringify("GSTNUMBER", response.data));
          if (response.data.success === true) {
            setUpdateDetail(response.data?.message?.vendorDetails);
            setGstLoading(false);
            setVerifedGst(false);
          }
        })
        .catch((error) => {
          setVerifedGst(false);
          console.log(error);
        });
    }
  };

  useEffect(() => {
    setTimeout(() => {
      setGstError("");
      setPanError("");
    }, 5000);
  }, [panError, gstError]);

  return (
    <Layout>
      <Container>
        {loading ? (
          <InfiLoader maintext="Fetching Documents..." />
        ) : (
          <div className="flex flex-wrap justify-between w-full h-full">
            <div className="flex flex-col px-2 py-2 w-[100%] h-[100%] overflow-scroll">
              <div className="h-[80%]">
                <div className="flex gap-2 border-b mb-6">
                  <TabBarItem
                    label="Documentation"
                    isActive={activeSection === "documentation"}
                    onClick={() => setActiveSection("documentation")}
                  />

                  <TabBarItem
                    label="API"
                    isActive={activeSection === "api"}
                    onClick={() => setActiveSection("api")}
                  />

                  <TabBarItem
                    label="Permissions"
                    isActive={activeSection === "permissions"}
                    onClick={() => setActiveSection("permissions")}
                  />
                </div>
                {activeSection === "documentation" && (
                  <div className="flex flex-col gap-6 mt-10">
                    {/* GST Verification */}
                    <div className="bg-white p-2 md:p-6 rounded-lg shadow-sm border">
                      <div className="flex gap-2">
                        <h3 className="text-sm md:text-lg font-semibold mb-4">
                          GST Verification
                        </h3>
                        {updateDetail?.gstDetails?.gstDocument && (
                          <div>
                            {updateDetail?.verificationDetails
                              ?.isGstVerified === false &&
                            updateDetail?.gstDetails?.gstDocument ? (
                              <span className="bg-yellow-50 border border-yellow-300 px-2 text-xs py-0.5 text-yellow-800 rounded">
                                Pending
                              </span>
                            ) : updateDetail?.verificationDetails
                                ?.isGstVerified === true &&
                              updateDetail?.gstDetails?.gstDocument ? (
                              <span className="bg-green-50 border border-green-300 px-2 text-xs py-0.5 text-green-800 rounded">
                                Verified
                              </span>
                            ) : (
                              ""
                            )}
                          </div>
                        )}
                      </div>
                      <div className="flex gap-4 items-start w-full">
                        <div className="w-full">
                          <div className="flex">
                            <div className="bg-zinc-50 px-2 text-xs py-0.5 text-slate-400 rounded">
                              {GstDetails?.legal_name}
                            </div>
                          </div>
                          <div className="flex items-center justify-between w-full p-2 border rounded">
                            <input
                              type="text"
                              disabled={updateDetail?.gstDetails?.gstNumber}
                              placeholder="Enter GST Number"
                              className={`px-2 w-full outline-none md:text-base text-xs bg-white ${
                                updateDetail?.gstDetails?.gstNumber
                                  ? "text-zinc-400"
                                  : "text-black"
                              }`}
                              value={gstNumber}
                              maxLength={15}
                              onChange={(e) =>
                                setGstNumber(e.target.value.slice(0, 15))
                              }
                            />
                            {gstProccessing && <loader.staggerCircle />}
                          </div>
                          {gstError && (
                            <p className="text-red-500 text-sm mt-1">
                              {gstError}
                            </p>
                          )}
                        </div>
                      </div>
                      {verifiedGst && (
                        <div className="mt-4">
                          <div className="flex items-center gap-2 text-green-600 mb-3">
                            <TiTick size={20} />
                            <span>Verified Successfully</span>
                          </div>
                          <div className="flex justify-between">
                            <div className="flex items-center gap-4">
                              <input
                                type="file"
                                id="gst-doc"
                                className="hidden"
                                onChange={(e) =>
                                  setGstDocument(e.target.files[0])
                                }
                              />
                              <label
                                htmlFor="gst-doc"
                                className="flex items-center gap-2 cursor-pointer px-4 py-2 bg-gray-100 rounded hover:bg-gray-200"
                              >
                                <FiUpload />
                                <span>Upload Document</span>
                              </label>
                              {gstDocument && (
                                <span className="text-sm text-gray-600">
                                  {gstUrlStatus}
                                </span>
                              )}
                            </div>
                            <BlackButton
                              loading={gstLoading}
                              title="Update"
                              handleSubmit={GstDocUploadHandler}
                              disabled={gstUrl === ""}
                            />
                          </div>
                        </div>
                      )}
                    </div>

                    {/* PAN Verification */}
                    <div className="bg-white p-2 md:p-6 rounded-lg shadow-sm border">
                      <div className="flex gap-2">
                        <h3 className="text-sm md:text-lg font-semibold mb-4">
                          PAN Verification
                        </h3>
                        {updateDetail?.panDetails?.panDocument && (
                          <div>
                            {updateDetail?.verificationDetails
                              ?.isGstVerified === false &&
                            updateDetail?.panDetails?.panDocument ? (
                              <span className="bg-yellow-50 border border-yellow-300 px-2 text-xs py-0.5 text-yellow-800 rounded">
                                Pending
                              </span>
                            ) : updateDetail?.verificationDetails
                                ?.isGstVerified === true &&
                              updateDetail?.panDetails?.panDocument ? (
                              <span className="bg-green-50 border border-green-300 px-2 text-xs py-0.5 text-green-800 rounded">
                                Verified
                              </span>
                            ) : (
                              ""
                            )}
                          </div>
                        )}
                      </div>
                      <div className="flex gap-4 items-start">
                        <div className="flex-1">
                          <div className="flex">
                            <div className="bg-zinc-50 px-2 text-xs py-0.5 text-slate-400">
                              {penDocument?.full_name}
                            </div>
                          </div>
                          <div className="flex items-center justify-between w-full p-2 border rounded">
                            <input
                              type="text"
                              placeholder="Enter PAN Number"
                              className={`px-2 w-full outline-none md:text-base text-xs bg-white ${
                                updateDetail?.panDetails?.panNumber
                                  ? "text-zinc-400"
                                  : "text-black"
                              }`}
                              value={panNumber}
                              maxLength={10}
                              onChange={(e) =>
                                setPanNumber(e.target.value.slice(0, 10))
                              }
                              disabled={updateDetail?.panDetails?.panNumber}
                            />
                            {panProccessing && <loader.staggerCircle />}
                          </div>
                          {panError && (
                            <p className="text-red-500 text-sm mt-1">
                              {panError}
                            </p>
                          )}
                        </div>
                      </div>
                      {verifiedPan && (
                        <div className="mt-4">
                          <div className="flex items-center gap-2 text-green-600 mb-3">
                            <TiTick size={20} />
                            <span>Verified Successfully</span>
                          </div>
                          <div className="flex justify-between">
                            <div className="flex items-center gap-4">
                              <input
                                type="file"
                                id="pan-doc"
                                className="hidden"
                                onChange={(e) =>
                                  setPanDocument(e.target.files[0])
                                }
                              />
                              <label
                                htmlFor="pan-doc"
                                className="flex items-center gap-2 cursor-pointer px-4 py-2 bg-gray-100 rounded hover:bg-gray-200"
                              >
                                <FiUpload />
                                <span>Upload Document</span>
                              </label>
                              {panDocument && (
                                <span className="text-sm text-gray-600">
                                  {panUrlStatus}
                                </span>
                              )}
                            </div>
                            <BlackButton
                              loading={panLoading}
                              title="Update"
                              handleSubmit={PanDocUploadHandler}
                              disabled={panUrl === ""}
                            />
                          </div>
                        </div>
                      )}
                    </div>

                    {/* Profile Image Upload */}
                    <div className="bg-white p-2 md:p-6 rounded-lg shadow-sm border">
                      <div className="flex gap-2">
                        <h3 className="text-sm md:text-lg font-semibold mb-4">
                          Upload Logo
                        </h3>
                      </div>
                      <div className="mt-4">
                        <div className="flex justify-between items-center">
                          <div className="flex items-center gap-4">
                            <input
                              type="file"
                              id="logo-upload"
                              className="hidden"
                              accept="image/*"
                              onChange={handleImageChange}
                            />
                            <label
                              htmlFor="logo-upload"
                              className="flex items-center gap-2 cursor-pointer px-4 py-2 bg-gray-100 rounded hover:bg-gray-200"
                            >
                              <FiUpload />
                              <span>
                                {logoUrl ? "Replace Image" : "Upload Image"}
                              </span>
                            </label>
                            {logoUrlStatus && (
                              <span className="text-sm text-gray-600">
                                {logoUrlStatus}
                              </span>
                            )}
                          </div>
                          <BlackButton
                            title="Update"
                            handleSubmit={updateVendorLogo}
                            disabled={!logoUrl}
                          />
                        </div>
                        {(logoUrl || vendor?.vendorDetails?.logo?.url) && (
                          <div className="mt-4">
                            <img
                              className="h-12 object-contain"
                              src={logoUrl || vendor?.vendorDetails?.logo?.url}
                              alt="Vendor Logo"
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}
                {activeSection === "api" && (
                  <div className="flex flex-col md:gap-8 mt-10">
                    <div className="text-gray-700 bg-slate-50 border-2 border-slate-200 px-2 py-2 md:px-6 md:py-4 rounded-lg w-full">
                      <div className="flex flex-col md:flex-row items-center space-y-2 md:space-y-0 space-x-4">
                        <div>
                          <label
                            htmlFor="apiName"
                            className="block text-gray-700 text-sm font-medium md:min-w-[120px]"
                          >
                            API Name
                          </label>
                        </div>
                        <div className="flex flex-grow">
                          <input
                            type="text"
                            id="apiName"
                            className="flex-grow border border-slate-300 rounded-md py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:ring-2 focus:ring-slate-500 focus:border-slate-500"
                            placeholder="Enter API name"
                          />
                        </div>
                        <div>
                          <button className="bg-slate-600 text-white text-xs md:text-base px-2 py-1 md:px-4 md:py-2 rounded-md hover-bg-slate-700 focus:outline-none focus:ring-2 focus:ring-slate-500">
                            Generate API
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="text-gray-700 border-2 border-slate-200 px-2 py-2 md:px-6 md:py-4 rounded-lg">
                      <div>
                        <h4 className="text-base font-medium text-slate-500 pl-6">
                          Your APIs
                        </h4>
                      </div>
                      <div className="flex flex-col gap-6">
                        <div className="text-gray-700 bg-slate-50 border-2 border-slate-200 px-2 py-2 md:px-6 md:py-4 rounded-lg w-full">
                          <div className="flex justify-between items-center mb-2">
                            <span className="font-semibold">API Key 1</span>
                            <button
                              onClick={() =>
                                copyToClipboard(apiUrl.url1, "url1")
                              }
                              className="bg-slate-600 text-white px-4 py-1 rounded hover-bg-slate-700 text-xs md:text-sm"
                            >
                              {copiedStatus.url1 ? "Copied" : "Copy"}
                            </button>
                          </div>
                          <div className="flex justify-between items-center">
                            <span className="text-sm text-gray-600">
                              {apiUrl.url2}
                            </span>
                            <button
                              onClick={() =>
                                copyToClipboard(apiUrl.url2, "url2")
                              }
                              className="bg-slate-600 text-white px-2 md:px-4 py-1 rounded hover-bg-slate-700 text-xs md:text-sm"
                            >
                              {copiedStatus.url2 ? "Copied" : "Copy URL"}
                            </button>
                          </div>
                        </div>
                        <div className="text-gray-700 bg-slate-50 border-2 border-slate-200 px-2 py-2 md:px-6 md:py-4 rounded-lg w-full">
                          <div className="flex justify-between items-center mb-2">
                            <span className="font-semibold">API Key 2</span>
                            <button
                              onClick={() =>
                                copyToClipboard(apiUrl.url3, "url3")
                              }
                              className="bg-slate-600 text-white px-4 py-1 rounded hover-bg-slate-700 text-sm"
                            >
                              {copiedStatus.url3 ? "Copied" : "Copy"}
                            </button>
                          </div>
                          <div className="flex justify-between items-center">
                            <span className="text-sm text-gray-600">
                              {apiUrl.url4}
                            </span>
                            <button
                              onClick={() =>
                                copyToClipboard(apiUrl.url4, "url4")
                              }
                              className="bg-slate-600 text-white px-2 md:px-4 py-1 rounded hover-bg-slate-700 text-xs md:text-sm"
                            >
                              {copiedStatus.url4 ? "Copied" : "Copy URL"}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {activeSection === "permissions" && (
                  <div className="flex flex-col gap-2 mt-10 bg-zinc-50 p-4 rounded-md">
                    <div className="text-gray-700 py-3 border-b">
                      <div className="flex justify-between">
                        <label
                          htmlFor="gupshup"
                          className="block text-gray-700 text-sm font-medium md:min-w-[120px]"
                        >
                          Gupshup
                        </label>
                        <div
                          onClick={() => handleToggleChange("gupshup")}
                          className={`w-12 h-6 flex items-center rounded-full p-1 cursor-pointer ${
                            formdata.gupshup ? "bg-gray-500" : "bg-gray-300"
                          }`}
                        >
                          <div
                            className={`bg-white w-3 h-3 lg:w-4 lg:h-4 rounded-full shadow-md transform ${
                              formdata.gupshup ? "translate-x-6" : ""
                            } transition-transform`}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="text-gray-700 py-3 border-b">
                      <div className="flex justify-between">
                        <label
                          htmlFor="shopify"
                          className="block text-gray-700 text-sm font-medium md:min-w-[120px]"
                        >
                          Shopify
                        </label>
                        <div
                          onClick={() => handleToggleChange("shopify")}
                          className={`w-12 h-6 flex items-center rounded-full p-1 cursor-pointer ${
                            formdata.shopify ? "bg-gray-500" : "bg-gray-300"
                          }`}
                        >
                          <div
                            className={`bg-white w-3 h-3 lg:w-4 lg:h-4 rounded-full shadow-md transform ${
                              formdata.shopify ? "translate-x-6" : ""
                            } transition-transform`}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="text-gray-700 py-3 rounded-lg">
                      <div className="flex justify-between">
                        <label
                          htmlFor="manual"
                          className="block text-gray-700 text-sm font-medium md:min-w-[120px]"
                        >
                          Manual
                        </label>
                        <div
                          onClick={() => handleToggleChange("manual")}
                          className={`w-12 h-6 flex items-center rounded-full p-1 cursor-pointer ${
                            formdata.manual ? "bg-gray-500" : "bg-gray-300"
                          }`}
                        >
                          <div
                            className={`bg-white w-3 h-3 lg:w-4 lg:h-4 rounded-full shadow-md transform ${
                              formdata.manual ? "translate-x-6" : ""
                            } transition-transform`}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </Container>
      {showPopup && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
          <div className="bg-white p-8 rounded-lg">
            <h2 className="text-2xl font-bold mb-4">
              {popupType.charAt(0).toUpperCase() + popupType.slice(1)}{" "}
              Integration
            </h2>
            <input
              type="text"
              placeholder="API Endpoint"
              className="w-full p-2 mb-4 border rounded"
            />
            <input
              type="text"
              placeholder="Access Token"
              className="w-full p-2 mb-4 border rounded"
            />
            <input
              type="text"
              placeholder="Secret Key"
              className="w-full p-2 mb-4 border rounded"
            />
            <input
              type="text"
              placeholder="API Key"
              className="w-full p-2 mb-4 border rounded"
            />
            <input
              type="text"
              placeholder="Version"
              className="w-full p-2 mb-4 border rounded"
            />
            <div className="flex justify-end">
              <button
                onClick={() => setShowPopup(false)}
                className="bg-gray-300 text-gray-800 px-4 py-2 rounded mr-2"
              >
                Cancel
              </button>
              <button
                onClick={() => setShowPopup(false)}
                className="bg-blue-500 text-white px-4 py-2 rounded"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}
    </Layout>
  );
}

export default Documents;
